import { IKnmListFilterExtra } from '../interfaces/IKnmListFilterExtra';

export const exclusionErknmAdditionalFields: (keyof IKnmListFilterExtra)[] = [
  'chlistFillingIndicationType',
  'dataSetNotInTime',
  'notifyLate',
  'address',
  'disapprove',
  'hasViolations',
  'knmAnnulled',
  'legalBasisDocName',
  'orderDone',
  'recEmptyOrLate',
  'regLate',
  'resultEmpty',
  'resultEmptyOrLate',
  'noPunishment',
  'subjectTypes',
  'admLevel',
  'inspectorFullName',
];
